<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <v-row>
      <v-col cols="12" md="6">
        <h2>
          マニフェスト詳細
          <v-chip
            v-if="!['before_reserve', 'none_use_approval'].includes(manifest.approval_status)"
            middle
            label
            :color="manifest.approval_status | approval_status_chip_color(manifest.manifest_registered)"
          >
            {{ manifest.approval_status | approval_status_chip_label(manifest.manifest_registered) }}
          </v-chip>
        </h2>
      </v-col>
    </v-row>

    <v-card
      v-if="manifest"
      flat
    >
      <v-card-text>

        <!-- １行目(マニフェスト・DXEマニフェスト番号・登録(取込)業者・DXE起票担当者) -->
        <v-row>
          <v-col
            v-if="manifest.level === 'first_manifest'"
            cols="12" md="3"
          >
            <div class="overline">
              マニフェスト
            </div>
            <h4>
              １次マニフェスト{{ manifest.manifest_type | manifest_type_to_label_light }}
            </h4>
            <v-divider />
          </v-col>

          <v-col
            v-else
            cols="12" md="3"
          >
            <v-row>
              <v-col cols="12" md="12">
                <div class="d-flex justify-space-between align-end">
                  <div>
                    <div class="overline">
                      マニフェスト
                    </div>
                    <h4>
                      ２次マニフェスト{{ manifest.manifest_type | manifest_type_to_label_light }}
                    </h4>
                  </div>
                  <v-btn
                    dark
                    small
                    color="primary"
                    class="mb-1"
                    style="width: 30px;min-width: initial"
                    @click="openPreviouslyManifestDialogClickEvent"
                  >
                    <v-icon dark small>
                      mdi-link-edit
                    </v-icon>
                  </v-btn>
                </div>
                <v-divider />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="3">
            <div class="overline">
              DXEマニフェスト番号
            </div>
            <h4>{{ manifest.id }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col
            v-if="manifest.manifest_type === 'transfer_form'"
            cols="12" md="3"
          >
            <div class="overline">
              JWNET取込業者
            </div>
            <h4>{{ manifest.self_transfer_manifest ? '自社' : '他社' }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col
            v-else
            cols="12" md="3"
          >
            <div class="overline">
              登録業者
            </div>
            <h4>{{ manifest.self_manifest ? '自社' : '他社' }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="3">
            <div class="overline">
              DXE起票担当者
            </div>
            <h4>{{ manifest.self_manifest ? manifest.dxe_vote_staff : '-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /１行目(マニフェスト・DXEマニフェスト番号・登録(取込)業者・DXE起票担当者) -->

        <!-- ２行目(排出者メール承認・受注番号・引取搬入番号) -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              排出者メール承認
            </div>
            <h4
              v-if="manifest.self_manifest && manifest.level === 'first_manifest' && manifest.manifest_type === 'dxe_form'"
            >
              {{ manifest.approval_status === 'none_use_approval' ? '利用しない' : '利用する' }}&nbsp;
            </h4>
            <h4
              v-else
            >
              -&nbsp;
            </h4>
            <v-divider />
          </v-col>

          <v-col
            cols="12" md="3"
          >
            <v-row>
              <v-col cols="12" md="12">
                <div class="d-flex justify-space-between align-end">
                  <div>
                    <div class="overline">
                      受注番号
                    </div>
                    <h4
                      v-if="!manifest.manifest_canceled && manifest.level === 'first_manifest'"
                    >
                      {{ manifest.order_no ? manifest.order_no : '-' }}&nbsp;
                    </h4>
                    <h4
                      v-else
                    >
                      -&nbsp;
                    </h4>
                  </div>
                  <div
                    v-if="!manifest.order_id && !manifest.manifest_canceled && manifest.level === 'first_manifest'"
                  >
                    <v-btn
                      dark
                      small
                      bottom
                      text-right
                      color="primary"
                      class="mb-1"
                      style="width: 30px;min-width: 0;"
                      @click="openOrderNumberDialogClickEvent"
                    >
                      <v-icon dark small>
                        mdi-link-edit
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <v-divider />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="3">
            <div class="overline">
              引取搬入番号
            </div>
            <h4>{{ manifest.request_nos ? manifest.request_nos : '-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /２行目(排出者メール承認・受注番号・引取搬入番号) -->

        <!-- ３行目(DXE２次マニフェスト番号・２次マニフェスト番号) -->
        <v-row
          v-if="manifest.level === 'first_manifest'"
        >
          <v-col
            cols="12" md="3"
          >
            <div class="overline">
              DXE２次マニフェスト番号
            </div>
            <h4>{{ manifest.second_manifest_ids ? manifest.second_manifest_ids : '&nbsp;-' }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col
            cols="12" md="3"
          >
            <div class="overline">
              ２次マニフェスト番号
            </div>
            <h4>{{ manifest.second_manifest_nos ? manifest.second_manifest_nos : '&nbsp;-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /３行目(DXE２次マニフェスト番号・２次マニフェスト番号) -->

        <!-- ４行目(判定日時・排出差戻理由) -->
        <v-row
          v-if="manifest.level === 'first_manifest' && manifest.manifest_type === 'dxe_form' && manifest.approval_status !== 'none_use_approval'"
        >
          <v-col cols="12" md="6">
            <div class="overline">
              排出判定日時
            </div>
            <h4>
              {{ manifest.approval_judgment_at | unix_datetime_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="6">
            <div class="overline">
              排出差戻理由
            </div>
            <h4 class="red--text">
              {{ manifest.approval_remand_reason }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /４行目(判定日時・排出差戻理由) -->

      </v-card-text>

      <!-- 排出事業者 -->
      <v-card-title>
        <span style="color: #0074BA">排出事業者情報</span>&emsp;
      </v-card-title>
      <v-card-text>
        <!-- 会社名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              会社名
            </div>
            <h4>{{ manifest.supplier.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /会社名 -->
        <!-- 住所 -->
        <v-row>
          <v-col cols="12">
            <div class="overline">
              住所
            </div>
            <h4>
              <span v-if="manifest.supplier.zip_code">〒{{ manifest.supplier.zip_code }}</span>&emsp;
              {{ manifest.supplier.address }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /住所 -->
        <!-- 電話番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ manifest.supplier.phone_number || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /電話番号 -->
      </v-card-text>
      <!-- /排出事業者 -->

      <!-- 引渡し日 -->
      <v-card-title>
        <span style="color: #0074BA">引渡し日</span>&emsp;
        <v-btn
          v-if="manifest.can_edit"
          small
          @click="enableCollectDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              引渡し日
            </div>
            <h4>{{ manifest.collected_date | date_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /引渡し日 -->

      <!-- 連絡番号１／連絡番号２ -->
      <v-card-title>
        <span style="color: #0074BA">連絡番号</span>&emsp;
        <v-btn
          v-if="manifest.can_edit"
          small
          @click="enableContactNumberDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              連絡番号１
            </div>
            <h4>{{ manifest.supplier.contact_number_1 || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              連絡番号２
            </div>
            <h4>{{ manifest.supplier.contact_number_2 || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              連絡番号３
            </div>
            <h4>{{ manifest.supplier.contact_number_3 || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /連絡番号１／連絡番号２ -->

      <!-- 事業場情報 -->
      <v-card-title>
        <span style="color: #0074BA">排出事業場情報</span>&emsp;
      </v-card-title>
      <v-card-text>
        <!-- 事業場名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業場名
            </div>
            <h4>{{ manifest.supplier_location.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /事業場名 -->
        <!-- 事業場住所 -->
        <v-row>
          <v-col cols="12">
            <div class="overline">
              住所
            </div>
            <h4>
              <span v-if="manifest.supplier_location.zip_code">〒{{ manifest.supplier_location.zip_code }}</span>&emsp;
              {{ manifest.supplier_location.address }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /事業場住所 -->
        <!-- 電話番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ manifest.supplier_location.phone_number || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /電話番号 -->
      </v-card-text>
      <!-- /事業場情報 -->

      <!-- 運搬情報 -->
      <v-card-title>
        <span style="color: #0074BA">運搬情報</span>&emsp;
        <v-btn
          v-if="manifest.can_edit"
          small
          @click="enableTransportLocationDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- 引渡担当者名・登録担当者名 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              引渡担当者名
            </div>
            <h4>{{ manifest.supplier.deliver_staff || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              登録担当者名
            </div>
            <h4>{{ manifest.supplier.register_staff || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /引渡担当者名・登録担当者名 -->

        <!-- 運搬方法・運搬担当者・車両番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬担当者
            </div>
            <h4>
              {{ manifest.transport_user_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬方法
            </div>
            <h4>
              {{ manifest.transportation_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              車両番号
            </div>
            <h4>
              {{ manifest.vehicle_number }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /運搬方法・運搬担当者・車両番号 -->

      </v-card-text>
      <!-- /運搬情報 -->

      <!-- 廃棄物情報 -->
      <v-card-title>

        <v-tabs background-color="blue-grey lighten-4 mb-4">
          <v-tab>{{ manifest.item_name || '未設定' }}</v-tab>
        </v-tabs>

        <span style="color: #0074BA">廃棄物情報</span>&emsp;
        <v-btn
          v-if="manifest.can_edit"
          small
          @click="enableWasteDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- マニフェスト番号／起票支店/営業所名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              マニフェスト番号
            </div>
            <h4>{{ manifest.manifest_no || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              起票支店/営業所名
            </div>
            <h4>{{ manifest.tenant_name || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /マニフェスト番号／起票支店/営業所名 -->
      </v-card-text>

      <v-card-text>
        <!-- 取扱品目／廃棄物の名称 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              取扱品目
            </div>
            <h4>{{ manifest.item_name }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              廃棄物の名称
            </div>
            <h4>{{ manifest.waste_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /取扱品目／廃棄物の名称 -->
        <!-- 数量・数量の確定者／荷姿・荷姿の数量 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              数量
            </div>
            <h4>{{ manifest.quantity }}&nbsp;{{ manifest.quantity_unit_name }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              数量の確定者
            </div>
            <h4>{{ manifest.quantity_confirm_name }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              荷姿
            </div>
            <h4>{{ manifest.packing_name || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              荷姿の数量
            </div>
            <h4>{{ manifest.packing_quantity }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /数量・数量の確定者／荷姿・荷姿の数量 -->
        <!-- 有害物質 -->
        <template v-if="hasHazardousSubstance">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <div class="overline">
              有害物質１
            </div>
            <h4>{{ manifest.hazardous_substance_1_name || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <div class="overline">
              有害物質２
            </div>
            <h4>{{ manifest.hazardous_substance_2_name || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <div class="overline">
              有害物質３
            </div>
            <h4>{{ manifest.hazardous_substance_3_name || '-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <div class="overline">
              有害物質４
            </div>
            <h4>{{ manifest.hazardous_substance_4_name || '-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <div class="overline">
              有害物質５
            </div>
            <h4>{{ manifest.hazardous_substance_5_name || '-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <div class="overline">
              有害物質６
            </div>
            <h4>{{ manifest.hazardous_substance_6_name || '-' }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        </template>
        <!-- /有害物質 -->
        <!-- 確定数量 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              確定数量（確定数量の単位）
            </div>
            <h4>{{ manifest.report_transport_quantity }}&nbsp;{{ manifest.report_transport_quantity_unit_name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /確定数量 -->
      </v-card-text>
      <!-- 廃棄物情報 -->

      <!-- 運搬ルート -->
      <v-card-title>
        <span style="color: #0074BA">運搬ルート</span>&emsp;
        <v-btn
          v-if="manifest.can_edit && !manifest.already_registered"
          small
          @click="enableDisposerLocationDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text>

        <!-- ルートコード・ルート名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              ルート名
            </div>
            <h4>
              {{ manifest.transport_route_name || '-' }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /ルートコード・ルート名 -->
        <!-- ルート詳細 -->
        <transport-route-result
          :custom-mode="true"
          :form="manifest"
          :transport-route-id="manifest.transport_route_id"
          :emission="manifest.supplier"
          :master-mode="true"
        />
        <!-- /ルート詳細 -->
        <!-- 処分方法 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              処分方法
            </div>
            <h4>
              {{ manifest.disposal_method_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /処分方法 -->
      </v-card-text>
      <!-- 運搬終了報告 1〜５-->
      <transport-report-result :manifest-transports="manifest.manifest_transports" />
      <!-- /運搬終了報告 1〜５-->
      <!-- /運搬ルート -->

      <!-- 処分報告 -->
      <v-card-title>
        <span style="color: #0074BA">処分報告</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              報告区分
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_type_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              処分終了日
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_end_date | date_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              処分担当者
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_person }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              報告担当者
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_reporter }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              廃棄物受領日
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_receipt_date | date_format }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬担当者
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_driver }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              車両番号
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_vehicle_number }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              受入量
            </div>
            <h4>{{ manifest.disposal_report.disposal_report_amount }}&nbsp;{{ manifest.disposal_report.disposal_report_amount_unit_name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              処分終了報告日時
            </div>
            <h4 v-if="['transfer_form'].includes(manifest.manifest_type)">
              {{ manifest.disposal_report.disposal_end_at | unix_date_format }}&nbsp;
            </h4>
            <h4 v-else>
              {{ manifest.disposal_report.disposal_end_at | unix_datetime_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              最終処分終了日
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_end_last_date }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              最終処分終了報告日時
            </div>
            <h4>
              {{ manifest.disposal_report.final_disposal_end_at }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="overline">
              処分備考
            </div>
            <h4>
              {{ manifest.disposal_report.disposal_report_remarks }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /処分報告 -->

      <!-- 最終処分 -->
      <v-card-title>
        <span style="color: #0074BA">最終処分</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="manifest.final_disposals"
          disable-sort
          hide-default-footer
          no-data-text=" "
        >
          <template v-slot:[`item.name`]="{item}">
            {{ item.name }}
            <v-tooltip
              top
              :open-on-hover="false"
            >
              <template #activator="{ on }">
                <v-btn
                  v-if="item.address"
                  icon
                  small
                  retain-focus-on-click
                  @click="on.click"
                  @blur="on.blur"
                >
                  <v-icon small>
                    mdi-map-marker-outline
                  </v-icon>
                </v-btn>
              </template>
              <small
                v-if="item.address"
              >
                {{ item.address }}
              </small>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
      <!-- /最終処分 -->

      <!-- 再資源化等の情報詳細 -->
      <!-- /再資源化等の情報詳細 -->

      <!-- JWNET備考 -->
      <v-card-title>
        <span style="color: #0074BA">JWNET備考</span>&emsp;
        <v-btn
          v-if="manifest.can_edit"
          small
          @click="enableTransportNoteDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              備考１
            </div>
            <h4>
              {{ manifest.note_1 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              備考２
            </div>
            <h4>
              {{ manifest.note_2 }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              備考３
            </div>
            <h4>
              {{ manifest.note_3 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              備考４
            </div>
            <h4>
              {{ manifest.note_4 }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              備考５
            </div>
            <h4>
              {{ manifest.note_5 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /JWNET備考 -->

      <!-- カスタムラベル -->
      <v-card-title
        v-if="isJwMode"
      >
        <span v-if="manifest.custom_label.use_title" style="color: #0074BA">{{ manifest.custom_label.name_title }}</span>&emsp;
        <v-btn
          v-if="manifest.custom_label.custom_labels1_use || manifest.custom_label.custom_labels2_use || manifest.custom_label.custom_labels3_use ||
                manifest.custom_label.custom_labels4_use || manifest.custom_label.custom_labels5_use || manifest.custom_label.custom_labels6_use"
          small
          @click="enableManifestCustomLabelDialogButtonClickEvent(manifest)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-card-text
        v-if="isJwMode"
      >
        <v-row>
          <v-col cols="12" md="6" v-if="manifest.custom_label.custom_labels1_use">
            <div class="overline">
              {{ manifest.custom_label.custom_labels1_name }}
            </div>
            <h4>
              {{ manifest.manifest_custom_label.custom_labels_1 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6" v-if="manifest.custom_label.custom_labels2_use">
            <div class="overline">
              {{ manifest.custom_label.custom_labels2_name }}
            </div>
            <h4>
              {{ manifest.manifest_custom_label.custom_labels_2 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6" v-if="manifest.custom_label.custom_labels3_use">
            <div class="overline">
              {{ manifest.custom_label.custom_labels3_name }}
            </div>
            <h4>
              {{ manifest.manifest_custom_label.custom_labels_3 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6" v-if="manifest.custom_label.custom_labels4_use">
            <div class="overline">
              {{ manifest.custom_label.custom_labels4_name }}
            </div>
            <h4>
              {{ manifest.manifest_custom_label.custom_labels_4 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6" v-if="manifest.custom_label.custom_labels5_use">
            <div class="overline">
              {{ manifest.custom_label.custom_labels5_name }}
            </div>
            <h4>
              {{ manifest.manifest_custom_label.custom_labels_5 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6" v-if="manifest.custom_label.custom_labels6_use">
            <div class="overline">
              {{ manifest.custom_label.custom_labels6_name }}
            </div>
            <h4>
              {{ manifest.manifest_custom_label.custom_labels_6 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /カスタムラベル -->

      <v-card
        v-if="manifest.manifest_type === 'paper_form'"
        class="mb-5"
        flat
        tile
      >
        <v-card-title>
          <span style="color: #0074BA">紙マニフェスト返却日</span>&emsp;
        </v-card-title>
        <v-card-text>
          <!-- A票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                A票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.a_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                A票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.a_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /A票 -->
          <!-- B2票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                B2票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b2_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                B2票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b2_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /B2票 -->
          <!-- B4票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                B4票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b4_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                B4票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b4_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /B4票 -->
          <!-- B6票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                B6票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b6_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                B6票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b6_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /B6票 -->
          <!-- D票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                D票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.d_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                D票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.d_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /D票 -->
          <!-- E票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                E票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.e_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                E票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.e_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /E票 -->
          <!-- B1票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                B1票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b1_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                B1票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.b1_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /B1票 -->
          <!-- C1票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                C1票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.c1_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                C1票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.c1_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /C1票 -->
          <!-- C2票 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                C2票&nbsp;返却日
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.c2_return_date | date_format }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="9">
              <div class="overline">
                C2票&nbsp;返却先
              </div>
              <h4>
                {{ manifest.paper_manifest_return_vote.c2_return_target }}&nbsp;&nbsp;
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /C2票 -->
        </v-card-text>

      </v-card>

      <!-- マニフェスト検索キーワード -->
      <v-card-title>
        <span style="color: #0074BA">マニフェスト検索キーワード</span>&emsp;
        <edit-manifest-search-keyword-dialog
          :manifest-id="manifest.id"
          @registerCallback="dialogRegisterCallBack"
        />
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline" style="text-transform: none">
              マニフェスト検索キーワード&nbsp;
              <span class="red--text font-weight-bold">&emsp;※&nbsp;DXEStation排出モードにも表示されます。&nbsp;</span>
            </div>
            <h4>
              {{ manifest.manifest_search_keyword }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /マニフェスト検索キーワード -->

      <!-- 再資源化等処理情報 -->
      <template v-if="showRecycleDisposalReport">
        <v-card-title>
          <span style="color: #0074BA">再資源化等の情報詳細</span>
        </v-card-title>
        <v-card-text>
          <!-- 基準重量・重量 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                基準重量
              </div>
              <h4>
                {{ manifest.reported_standard_quantity_type_name || '-' }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="3">
              <div class="overline">
                重量
              </div>
              <h4>
                {{ manifest.reported_quantity ? `${manifest.reported_quantity}kg` : '-' }}
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /基準重量・重量 -->
          <div class="mt-2">
            <recycle-step-table
              :headers="headers"
              :result-list="manifest.manifest_recycle_disposal_reports || []"
              :reference-only="true"
            />
          </div>

        </v-card-text>
      </template>
      <template v-else-if="(this.mode === 'transport_disposal' || this.mode === 'disposal')">
        <v-card-title>
          <span style="color: #0074BA">再資源化等処理情報</span>&emsp;
          <edit-recycle-disposal-report-dialog
            :disabled="!manifest.can_edit_recycle"
            :manifest-id="manifest.id"
            @registered="recycleDisposalMiddleReportCallback"
          />
        </v-card-title>
        <v-card-text>
          <!-- 基準重量・数量 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                基準重量
              </div>
              <h4>
                {{ !manifest.final_disposal_completed && manifest.disposal_report && manifest.disposal_standard_quantity_type_name ? manifest.disposal_standard_quantity_type_name : '-' }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="3">
              <div class="overline">
                重量
              </div>
              <h4>
                {{ !manifest.final_disposal_completed && manifest.disposal_report && manifest.disposal_quantity ? `${manifest.disposal_quantity}kg` : '-' }}
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <!-- /基準重量・重量 -->
              <div class="mt-2">
                <recycle-step-table
                  :headers="recycleDisposalMiddleReportHeaders"
                  :result-list="manifest.manifest_recycle_disposal_middle_reports || []"
                  :reference-only="true"
                />
              </div>

            </v-col>
          </v-row>
        </v-card-text>
      </template>
      <!-- /再資源化等処理情報 -->

      <v-card-actions>
        <v-btn
          :disabled="!manifest.canceled"
          manifest_condition
          class="error"
          @click="cancelButtonClickEvent"
        >
          <span style="width: 100px">取消</span>
        </v-btn>
        <v-spacer />

        <v-btn
          v-if="['await_approval', 'remand'].includes(manifest.approval_status)"
          color="primary"
          class="mr-3"
          @click="enableMailApprovalDialogButtonClickEvent(manifest)"
        >
          排出再申請
        </v-btn>

        <v-btn
          @click="backButtonClickEvent"
        >
          <span style="width: 100px">戻る</span>
        </v-btn>
      </v-card-actions>
    </v-card>
    <edit-order-number-dialog
      :enable-dialog="enableEditOrderNumberDialog"
      :target-manifest-id="targetManifestId"
      :target-order-no="targetOrderNo"
      @closeCallback="closeDialogCallback"
      @registerCallback="registerOrderNumberDialogButtonClickEvent"
      @deleteCallback="deleteOrderNumberDialogButtonClickEvent"
    />
    <selectable-previously-manifest-dialog
      :enable-dialog="enablePreviouslyManifestDialog"
      :target-manifest-id="targetManifestId"
      :is-register="isRegister"
      :is-jwmode="isJwMode"
      :custom-label="manifest.custom_label"
      @closeCallback="closeDialogCallback"
      @registerCallback="registerPreviouslyManifestDialogCallback"
    />
    <edit-collect-dialog
      :enable-dialog="enableCollectDialog"
      :manifest-id="targetManifestId"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-waste-dialog
      :enable-dialog="enableWasteDialog"
      :manifest-id="targetManifestId"
      :packings="packings"
      :quantity-units="quantityUnits"
      :quantity-confirms="quantityConfirms"
      :hazardous-substances="hazardousSubstances"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-emission-dialog
      :enable-dialog="enableEmissionDialog"
      :manifest-id="targetManifestId"
      :deliverers="deliverers"
      :registers="registers"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-contact-number-dialog
      :enable-dialog="enableContactNumberDialog"
      :manifest-id="targetManifestId"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-transport-note-dialog
      :enable-dialog="enableTransportNoteDialog"
      :manifest-id="targetManifestId"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-transport-location-dialog
      :enable-dialog="enableTransportLocationDialog"
      :manifest-id="targetManifestId"
      :transportations="transportations"
      :deliverers="deliverers"
      :registers="registers"
      :drivers="drivers"
      :vehicles="vehicles"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-disposer-location-dialog
      :enable-dialog="enableDisposerLocationDialog"
      :manifest-id="targetManifestId"
      :disposal-methods="disposalMethods"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <edit-manifest-custom-label-dialog
      :enable-dialog="enableManifestCustomLabelDialog"
      :manifest-id="targetManifestId"
      :custom-label="manifest.custom_label"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <send-mail-approval-dialog
      :enable-dialog="enableMailApprovalDialog"
      :manifest-id="targetManifestId"
      @closeCallback="closeDialogCallback"
      @registerCallback="sendDialogRegisterCallBack"
    />
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PrefectureList from '../../../../mixins/PrefectureList'
import EditWasteDialog from './dialogs/_EditWasteDialog'
import EditOrderNumberDialog from './dialogs/_EditOrderNumberDialog'
import EditEmissionDialog from './dialogs/_EditEmissionDialog'
import EditCollectDialog from './dialogs/_EditCollectDialog'
import EditContactNumberDialog from './dialogs/_EditContactNumberDialog'
import EditTransportNoteDialog from './dialogs/_EditTransportNoteDialog'
import EditTransportLocationDialog from './dialogs/_EditTransportLocationDialog'
import EditDisposerLocationDialog from './dialogs/_EditDisposerLocationDialog'
import EditManifestCustomLabelDialog from './dialogs/_EditManifestCustomLabelDialog'
import SendMailApprovalDialog from './dialogs/_SendMailApprovalDialog'
import TransportRouteResult from '../../../components/TransportRouteResult'
import TransportReportResult from '../../../components/TransportReportResult'
import SelectablePreviouslyManifestDialog from './dialogs/_SelectablePreviouslyManifestDialog'
import EditManifestSearchKeywordDialog from './dialogs/_EditManifestSearchKeywordDialog'
import Confirm from '@/components/Confirm'

import EditRecycleDisposalReportDialog
  from "@/driver/pages/manifest/managements/dialogs/_EditRecycleDisposalReportDialog.vue";

export default {
  name: "DriverManifestManagement",
  components: {
    TransportRouteResult,
    TransportReportResult,
    EditWasteDialog,
    EditEmissionDialog,
    EditOrderNumberDialog,
    EditCollectDialog,
    EditContactNumberDialog,
    EditTransportNoteDialog,
    EditTransportLocationDialog,
    EditDisposerLocationDialog,
    EditManifestCustomLabelDialog,
    EditManifestSearchKeywordDialog,
    SendMailApprovalDialog,
    SelectablePreviouslyManifestDialog,
    EditRecycleDisposalReportDialog,
    Confirm,
  },
  mixins: [
    PrefectureList,
  ],
  props: {},
  data() {
    return {
      enableWasteDialog: false,
      enableCollectDialog: false,
      enableContactNumberDialog: false,
      enableEmissionDialog: false,
      enableTransportNoteDialog: false,
      enableTransportLocationDialog: false,
      enableDisposerLocationDialog: false,
      enableEditOrderNumberDialog: false,
      enablePreviouslyManifestDialog: false,
      enableManifestCustomLabelDialog: false,
      enableMailApprovalDialog: false,
      breadcrumbs: [],
      manifest: null,
      tableHeaders: [
        { value: 'final_disposal_date', text: '最終処分終了日' },
        { value: 'name', text: '最終処分事業場' }
      ],
      forms: {
        orderNumber: null,
      },
      recoveryOrderId: null,
      recoveryOrderType: null,
      targetManifestId: null,
      targetOrderNo: null,
      isRegister: false,
      transportations: [],
      deliverers: [],
      registers: [],
      packings: [],
      quantityUnits: [],
      quantityConfirms: [],
      hazardousSubstances: [],
      disposalMethods: [],
      items: [],
      drivers: [],
      vehicles: [],
      customLabel: null,
      headers: [
        {value: "level", text: "工程", width: "5%"},
        {value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "13%"},
        {value: "report_before_disposal_weight", text: "処分前重量", width: "5%"},
        {value: "disposal_method", text: "処分方法", width: "15%"},
        {value: "report_after_disposal_weight", text: "処理後重量", width: "5%"},
        {value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "15%"},
        {value: "final_disposal", text: "最終処分", width: "10%"},
        {value: "input_final_disposal_date", text: "最終処分終了日", width: "10%"},
        {value: "comment", text: "備考", width: "10%"},
      ],
      recycleDisposalMiddleReportHeaders: [
        {value: "level", text: "工程", width: "5%"},
        {value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "13%"},
        {value: "report_before_disposal_weight", text: "処分前重量", width: "5%"},
        {value: "disposal_method", text: "処分方法", width: "15%"},
        {value: "report_after_disposal_weight", text: "処理後重量", width: "5%"},
        {value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "15%"},
        {value: "final_disposal", text: "最終処分", width: "10%"},
        {value: "comment", text: "備考", width: "20%"},

      ],
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isJwMode: 'use_jw_mode',
      mode: 'mode',
    }),
    hasHazardousSubstance() {
      if (!this.manifest || !this.manifest.item_id) {
        return false;
      }
      const item = this.items.find(v => v.value === this.manifest.item_id);
      if (!item) {
        return false;
      }
      return item.use_harmful;
    },
    /**
     * 再資源化等の情報詳細の表示判定
     */
    showRecycleDisposalReport() {
      return (this.mode === 'transport_disposal' || this.mode === 'disposal') && this.manifest.manifest_recycle_disposal_reports.some(
        report => ['last_report', 'final_disposal_report'].includes(report.report_type)
      )
    },
  },
  watch: {},
  created() {
    this.recoveryOrderId = this.$route.params.order_id
    this.recoveryOrderType = this.$route.params.order_type

    this.fetchDrivers().then((content) => { this.drivers = content.drivers })
    this.fetchVehicles({ registered_number: true}).then((content) => { this.vehicles = content.vehicles })

    if (this.recoveryOrderType) {
      const params = { order_id: this.recoveryOrderId, order_type: this.recoveryOrderType }
      this.breadcrumbs.push({ text: 'マニフェスト一覧', disabled: false, to: { name: 'DriverManifestManagements', params: params}, exact: true })
    } else {
      this.breadcrumbs.push({ text: 'マニフェスト一覧', disabled: false, to: '/driver/manifest/managements', exact: true })
    }
    this.breadcrumbs.push({ text: 'マニフェストの詳細', disabled: true, to: '' })

    this.refreshDetail()
    this.fetchTransportations().then((content) => {
      this.transportations = content.transportations
    })
  },
  methods: {
    ...mapActions('DriverManifestManagement', {
      fetchManifest: 'show',
      cancelManifest: 'destroy'
    }),
    ...mapActions('DriverManifestManagementOrder', {
      updateOrderNumber: 'update',
    }),
    ...mapActions('DriverMasterSearchEmissionDeliverer', {
      fetchDeliverers: 'index',
    }),
    ...mapActions('DriverMasterSearchEmissionRegister', {
      fetchRegisters: 'index'
    }),
    ...mapActions('DriverMasterSearchTransportation', {
      fetchTransportations: 'index'
    }),
    ...mapActions('DriverMasterSearchPacking', {
      fetchPackings: 'index',
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index',
    }),
    ...mapActions('DriverMasterSearchQuantityConfirm', {
      fetchQuantityConfirms: 'index',
    }),
    ...mapActions('DriverMasterSearchHazardousSubstance', {
      fetchHazardousSubstances: 'index',
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index',
    }),
    ...mapActions('DriverMasterSearchDisposalMethod', {
      fetchDisposalMethods: 'index',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'index',
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search',
    }),
    ...mapActions('DriverMasterSearchCustomLabel', {
      fetchCustomLabel: 'index',
    }),
    /**
     * 取消しボタン クリックイベント
     */
     cancelButtonClickEvent () {
      let modalOption = { title: '取消', message: '取消しますがよろしいですか？', options: { width: 320, titleColor: 'red', isCancelButton: true } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.cancelManifest({ id: this.manifest.id }).then(() => {
            this.$router.push({name: 'DriverManifestManagements' })
          })
        }
      })
    },
    refreshDetail () {
      this.fetchManifest({ id: this.$route.params.id }).then((content) => {
        this.manifest = content
        this.deliverers = []
        this.registers = []

        if (this.manifest.level === 'first_manifest') {
          if (this.manifest.can_edit) {
            this.searchEmissionDeliverersBy(this.manifest.supplierable_id, this.manifest.supplierable_location_id)
            this.searchEmissionRegistersBy(this.manifest.supplierable_id, this.manifest.supplierable_location_id)
          }
        }
        if (this.manifest.can_edit) {
          this.fetchPackings().then((content) => {
            this.packings = content.packings
          })
          this.fetchQuantityUnits().then((content) => {
            this.quantityUnits = content.quantity_units
          })
          this.fetchQuantityConfirms().then((content) => {
            this.quantityConfirms = content.quantity_confirms
          })
          this.fetchHazardousSubstances().then((content) => {
            this.hazardousSubstances = content.hazardous_substances
          })
          this.fetchItems().then((content) => {
            this.items = content.items
          })
          this.fetchDisposalMethods().then((content) => {
            this.disposalMethods = content.disposal_methods
          })
          this.fetchCustomLabel().then((content) => {
            this.customLabel = content.custom_label
          })
        }
      })
    },
    enableWasteDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableWasteDialog = true
    },
    enableEmissionDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableEmissionDialog = true
    },
    enableCollectDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableCollectDialog = true
    },
    enableContactNumberDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableContactNumberDialog = true
    },
    enableTransportNoteDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableTransportNoteDialog = true
    },
    enableTransportLocationDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableTransportLocationDialog = true
    },
    enableDisposerLocationDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableDisposerLocationDialog = true
    },
    enableManifestCustomLabelDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableManifestCustomLabelDialog = true
    },
    enableMailApprovalDialogButtonClickEvent (manifest) {
      this.targetManifestId = manifest.id
      this.enableMailApprovalDialog = true
    },
    backButtonClickEvent () {
      let params = {}
      if (this.recoveryOrderType) {
        params = {order_id: this.recoveryOrderId, order_type: this.recoveryOrderType}
      }
      this.$router.push( { name: 'DriverManifestManagements', params: params } )
    },
    openOrderNumberDialogClickEvent () {
      this.targetManifestId = parseInt(this.$route.params.id)
      this.targetOrderNo= this.manifest.order_no
      this.enableEditOrderNumberDialog = true
    },
    openPreviouslyManifestDialogClickEvent () {
      this.targetManifestId = parseInt(this.$route.params.id)
      this.isRegister = this.manifest.is_register
      this.enablePreviouslyManifestDialog = true
    },
    closeDialogCallback () {
      this.enableWasteDialog = false
      this.enableCollectDialog = false
      this.enableContactNumberDialog = false
      this.enableEmissionDialog = false
      this.enableEditOrderNumberDialog = false
      this.enablePreviouslyManifestDialog = false
      this.enableTransportNoteDialog = false
      this.enableTransportLocationDialog = false
      this.enableDisposerLocationDialog = false
      this.enableManifestCustomLabelDialog = false
      this.enableMailApprovalDialog = false
    },
    /**
     * ダイアログ上での登録処理完了後のコールバック処理
     * ダイアログを閉じ、再取得を行う.
     */
    dialogRegisterCallBack () {
      this.closeDialogCallback()
      this.refreshDetail()
    },
    sendDialogRegisterCallBack () {
      this.closeDialogCallback()
      this.backButtonClickEvent()
    },
    searchEmissionDeliverersBy(emission_id, location_id) {
      if (emission_id) {
        this.fetchDeliverers({ id: emission_id, emission_location_id: location_id }).then((content) => {
          this.deliverers = content.deliverers
        })
      }
    },
    searchEmissionRegistersBy(emission_id, location_id) {
      if (emission_id) {
        this.fetchRegisters( { id: emission_id, emission_location_id: location_id }).then((content) => {
          this.registers = content.registers
        })
      }
    },
    registerPreviouslyManifestDialogCallback () {
      this.closeDialogCallback()
    },
    registerOrderNumberDialogButtonClickEvent (item) {
      const params = {
        order_no: item.order_no,
        order_type: item.order_type,
      }
      this.updateOrderNumber({ id: this.$route.params.id, params: params}).then(() => {
        // this.refreshDetail()
        this.fetchManifest({ id: this.$route.params.id }).then((content) => {
          this.manifest = content
          this.manifest.order_no = item.order_no
        })
        this.closeDialogCallback()
      })
    },
    deleteOrderNumberDialogButtonClickEvent () {
      const params = {
        deleted: true,
        order_no: this.manifest.order_no,
        order_type: this.manifest.order_type,
      }
      this.updateOrderNumber({ id: this.$route.params.id, params: params}).then(() => {
        this.fetchManifest({ id: this.$route.params.id }).then((content) => {
          this.manifest = content
          this.manifest.order_no = null
        })
        this.closeDialogCallback()
      })
    },
    recycleDisposalMiddleReportCallback (item) {
      this.manifest.disposal_standard_quantity_type_name = item.disposal_standard_quantity_type_name;
      this.manifest.disposal_quantity = item.disposal_quantity;
      this.manifest.manifest_recycle_disposal_middle_reports = item.manifest_recycle_disposal_middle_reports
      console.log(item);
    },
  }

}
</script>

<style scoped lang="scss">
.status-boxes {
  border: solid 1px #ddd;
  & span {
    min-width: 80px;
    display: inline-block;
  }
}
</style>
